import I from '../types.ts';

const getScrollParent: I['getScrollParent'] = function () {
    return document
        .querySelector('.public__page._public-blog')
        ?.querySelector('.public__innerPage._show') as HTMLElement;
};

export default getScrollParent;
